import { render, staticRenderFns } from "./TableauDeBord.vue?vue&type=template&id=2daa7b2d"
import script from "./TableauDeBord.vue?vue&type=script&lang=js"
export * from "./TableauDeBord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports